import { Injectable, effect, signal } from '@angular/core';
import { en, type TranslationKey, type Translations } from './en';
import { no } from './no';
import { AppLanguage, LANGUAGE_STORAGE_KEY, readInitialLanguage } from './languages';
import { da } from './da';
import { sv } from './sv';

const DICTIONARIES: Record<AppLanguage, Translations> = {
    en,
    nb: no,
    da,
    sv,
};

@Injectable({ providedIn: 'root' })
export class TranslateService {
    readonly language = signal<AppLanguage>(readInitialLanguage());

    constructor() {
        effect(() => {
            const code = this.language();
            document.documentElement.lang = code;
            try {
                localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
            } catch {
                // The choice still applies in memory.
            }
        });
    }

    t(key: TranslationKey): string {
        const dictionary = DICTIONARIES[this.language()];
        return dictionary[key] ?? en[key];
    }

    setLanguage(code: AppLanguage) {
        this.language.set(code);
    }
}